import { FGM } from "../brand";

export default function Hero() {
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-screen w-full overflow-hidden bg-black"
        >
            {/* Massive FGM eagle watermark — visible even before video loads */}
            <img
                src={FGM.logos.white}
                alt=""
                aria-hidden
                className="absolute right-[-8%] top-1/2 -translate-y-1/2 w-[720px] md:w-[900px] lg:w-[1100px] opacity-[0.08] pointer-events-none select-none z-0"
            />

            {/* Background video — plays over black + watermark */}
            <video
                data-testid="hero-video"
                autoPlay
                muted
                loop
                playsInline
                preload="auto"
                poster="/brand/hero-poster.jpg"
                className="absolute inset-0 w-full h-full object-cover z-[1]"
            >
                <source src={FGM.video} type="video/mp4" />
            </video>

            {/* Overlays */}
            <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/55 to-black z-[2]"></div>
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_20%,rgba(230,57,70,0.18),transparent_50%),radial-gradient(circle_at_80%_80%,rgba(29,78,216,0.18),transparent_55%)] z-[2]"></div>

            {/* Top vertical badge */}
            <div className="hidden md:flex absolute top-1/2 -translate-y-1/2 left-8 -rotate-90 origin-left items-center gap-3 text-white/50 text-xs tracking-[0.4em] font-display uppercase z-10">
                <span className="h-px w-10 bg-white/40 inline-block" />
                EST. <span className="text-white">FGM</span> · STREETWEAR
            </div>
            <div className="hidden md:flex absolute top-1/2 -translate-y-1/2 right-8 rotate-90 origin-right items-center gap-3 text-white/50 text-xs tracking-[0.4em] font-display uppercase z-10">
                <span className="h-px w-10 bg-white/40 inline-block" />
                FOR THE RELENTLESS
            </div>

            {/* Foreground content */}
            <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 min-h-screen flex flex-col justify-end pb-24 md:pb-32 pt-32">
                <div className="reveal reveal-delay-1">
                    <img
                        src={FGM.logos.white}
                        alt="FGM Apparel"
                        className="h-32 md:h-44 lg:h-52 w-auto mb-6 drop-shadow-2xl"
                        data-testid="hero-logo"
                    />
                </div>

                <h1
                    data-testid="hero-title"
                    className="reveal reveal-delay-2 font-display text-white text-[15vw] md:text-[10vw] lg:text-[8.5rem] leading-[0.85] tracking-tight uppercase"
                >
                    <span className="block">Focus.</span>
                    <span className="block text-white/70">Grind.</span>
                    <span className="block">
                        Motivate<span className="text-[#E63946]">.</span>
                    </span>
                </h1>

                <div className="reveal reveal-delay-3 mt-8 max-w-xl">
                    <div className="fgm-stripe-divider w-32 mb-6" />
                    <p className="text-zinc-300 text-base md:text-lg font-body leading-relaxed">
                        Streetwear for athletes, creators, runners, bikers — and
                        anyone who refuses to settle. Built to inspire confidence,
                        hustle, and individuality.
                    </p>
                </div>

                <div className="reveal reveal-delay-4 mt-10 flex flex-col sm:flex-row gap-4">
                    <a
                        href="#ambassador"
                        data-testid="hero-cta-apply"
                        className="btn-primary"
                    >
                        Become An Ambassador
                    </a>
                    <a
                        href="#manifesto"
                        data-testid="hero-cta-explore"
                        className="btn-outline"
                    >
                        Explore The Movement
                    </a>
                </div>
            </div>

            {/* Scroll indicator */}
            <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 text-white/40 text-[10px] tracking-[0.4em] font-display uppercase">
                Scroll
                <div className="w-px h-10 bg-gradient-to-b from-white/60 to-transparent" />
            </div>
        </section>
    );
}
